import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteUserDetailsAdmin,
  getAdminUserDetails,
  updateUserDetails,
  getAdminUserQuestions,
  postSaveUserQuestions,
  getAdminUserReports,
  postSaveUserReports,
  postAddUser,
  postAdminAddPackage,
} from "./Api";

// ? Initial State
export const initialState = {
  userDetails: [],
  email: "",
  number: "",
  error: "",
  loading: "",
};

// Async thunk action for user login
export const getAdminUsersDetails = createAsyncThunk(
  "admin/userDetails",
  async () => {
    const response = await getAdminUserDetails();
    return response.data;
  }
);
export const adminDeleteUser = createAsyncThunk(
  "admin/userDetails",
  async (id) => {
    const response = await deleteUserDetailsAdmin(id);
    return response.data;
  }
);
export const adminEditUser = createAsyncThunk(
  "admin/userDetails",
  async (data) => {
    const response = await updateUserDetails(data);
    return response.data;
  }
);

export const adminUserQuestions = createAsyncThunk(
  "admin/adminUserQuestions",
  async (id) => {
    const response = await getAdminUserQuestions(id);
    return response.data;
  }
);

export const adminSaveUserQuestions = createAsyncThunk(
  "admin/adminSaveUserQuestions",
  async (data) => {
    const response = await postSaveUserQuestions(data);
    return response.data;
  }
);

export const adminUserReports = createAsyncThunk(
  "admin/adminUserReports",
  async (id) => {
    const response = await getAdminUserReports(id);
    return response.data;
  }
);

export const adminSaveUserReports = createAsyncThunk(
  "admin/adminSaveUserReports",
  async (data) => {
    const response = await postSaveUserReports(data);
    return response.data;
  }
);

export const adminAddUser = createAsyncThunk(
  "admin/adminAddUser",
  async (data) => {
    const response = await postAddUser(data);
    return response.data;
  }
);

export const adminAddPackage = createAsyncThunk(
  "admin/adminAddPackage",
  async (data) => {
    const response = await postAdminAddPackage(data);
    return response.data;
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // * ADMIN USER DETAILS
      .addCase(getAdminUsersDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminUsersDetails.fulfilled, (state, action) => {
        state.error = null;
        state.userDetails = action.payload;
        state.loading = false;
      })
      .addCase(getAdminUsersDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = "Invalid Credentials";
      });
  },
});

// Export the actions and reducer
export default adminSlice.reducer;
